import {FilterItemsType} from 'reducers/category/filters/filtersType';

export type FilterItemResponseType = {
    count: number;
    id: number;
    title: string;
    value: string;
    image: string;
};

export type FilterResponseType = {
    code: string;
    input: string;
    title: string;
    items?: FilterItemResponseType[];
};

/**
 * Prepare fetched filters data
 * @param {FilterResponseType[]} data - response data for filters
 * @return {FilterItemsType[]} - prepared filter data
 */
export const categoryFilterAdapter = (data: FilterResponseType[]): FilterItemsType[] => {
    const isThereItems = (
        arg: FilterResponseType,
    ): arg is FilterResponseType & {items: FilterItemResponseType[]} => Boolean(arg.items);

    return data.filter(isThereItems).map(({code, input, title, items}) => ({
        code,
        input,
        title,
        items: items.map(({title: itemTitle, value, id, image, count}) => ({
            title: itemTitle,
            value,
            value_id: id,
            image,
            count,
        })),
    }));
};
